import {Component, OnInit, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ToastsManager } from "@app/shared/util/toastr.service";

import { TableConfig } from '@app/shared/util/table-config.utils';

import { ProcessTypeCreateModalComponent } from './components/process-type-create-modal/process-type-create-modal.component';

import { ProcessType } from '@models/process-type.model';
import { ProcessTypeService } from '@services/process-type.service';
import { Log } from "ng2-logger";
import { PermissionService } from "@app/authentication/services/permission.service";

@Component({
    selector: 'app-process-types',
    templateUrl: './process-types.component.html',
    styleUrls: ['./process-types.component.scss']
})
export class ProcessTypesManagementComponent implements OnInit {
    _logger = Log.create(ProcessTypesManagementComponent.name);
    @ViewChild(ProcessTypeCreateModalComponent, {static: true}) processTypeFormModal: ProcessTypeCreateModalComponent;

    processTypes: ProcessType[] = [];
    tableConfig = new TableConfig();
    isLoadingProcessTypes = false;

    constructor(private processTypesService: ProcessTypeService,
                private permissionService: PermissionService,
                private toastr: ToastsManager, private translationService: TranslateService) {
    }

    ngOnInit() {
        this.getProcessTypes(this.tableConfig);
    }


    onFilter(tableConfig: TableConfig) {
        this.getProcessTypes(tableConfig);
    }

    openProcessTypeModal() {
        this.processTypeFormModal.open();
    }

    getProcessTypes(tableConfig = this.tableConfig) {
        this._logger.info("getProcessTypes::");
        this.isLoadingProcessTypes = true;
        this.processTypesService.getAllProcessTypes(tableConfig).subscribe(data => {
                this._logger.info("getProcessTypes:: API returned data", data);
                this.processTypes = data.processTypes;
                this.tableConfig.pager.count = data.count;
                this.isLoadingProcessTypes = false;
            },
            (error: any) => {
                this._logger.error("getProcessTypes:: API returned error", error);
                this.isLoadingProcessTypes = false;
            });
    }

    createProcessType(processType) {
        this._logger.info("createProcessType::");
        this.isLoadingProcessTypes = true;
        this.processTypesService.createProcessType(processType).subscribe(
            (data: any) => {
                this._logger.info("createProcessType:: API returned data", data);
                this.getProcessTypes();
                this.toastr.success(this.buildCreateMessage(data.name));
                this.isLoadingProcessTypes = false;
                this.processTypeFormModal.close();
            },
            (error: any) => {
                this._logger.info("createProcessType:: API returned error", error);
                this.isLoadingProcessTypes = false;
            }
        );
    }

    updateProcessType(processTypeUpdate) {
        this.isLoadingProcessTypes = true;
        this._logger.info("updateProcessType::");
        this.processTypesService.updateProcessType(processTypeUpdate.newProcessType).subscribe(
            (data: any) => {
                this._logger.info("updateProcessType:: API returned data", data);
                this.getProcessTypes();
                this.toastr.success(this.buildUpdateMessage(processTypeUpdate.previousProcessTypeName));
                this.isLoadingProcessTypes = false;
                this.processTypeFormModal.close();
            },
            (error: any) => {
                this._logger.error("updateProcessType:: API returned error", error);
                this.isLoadingProcessTypes = false;
            }
        );
    }

    deleteProcessType(processType) {
        this.isLoadingProcessTypes = true;
        this._logger.info("deleteProcessType::");
        this.processTypesService.deleteProcessType(processType).subscribe(
            (data: any) => {
                this._logger.info("deleteProcessType:: API returned data", data);
                this.getProcessTypes();
                this.toastr.warning(this.buildDeleteMessage(processType.name));
                this.isLoadingProcessTypes = false;
                this.processTypeFormModal.close();
            },
            (error: any) => {
                this._logger.error("deleteProcessType:: API returned error", error);
                this.isLoadingProcessTypes = false;
            }
        );
    }

    buildCreateMessage(processTypeName) {
        return this.translationService.instant('admin.equipment.processTypes.toasts.created',
            {processTypeName: processTypeName});
    }

    buildUpdateMessage(processTypeName) {
        return this.translationService.instant('admin.equipment.processTypes.toasts.updated',
            {processTypeName: processTypeName});
    }

    buildDeleteMessage(processTypeName) {
        return this.translationService.instant('admin.equipment.processTypes.toasts.deleted',
            {processTypeName: processTypeName});
    }

    onSortChange(tableState) {
        this.getProcessTypes(tableState);
    }

    onPageChange(tableState) {
        this.getProcessTypes(tableState);
    }

    onTableRowClick(processType: ProcessType) {
        this.processTypeFormModal.open(processType);
    }

    shouldRenderModifiers() {
        return this.permissionService.hasHasPermissionForFeature('MANAGE_PROCESS_TYPES');
    }
}
